export default "__VITE_ASSET__BrmxdRNd__"